import React from 'react';

import { Box, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ChipProposalStatus, ProposalStatusIcon } from 'common/components';
import { getStatusProposalLabel } from 'common/utils/helpers';

import HeaderBreadcrumbs from './HeaderBreadcrumbs';
import TitlePreview from './TitlePreview';

const HeaderPreview = ({ creditId, fromQuote, hasApproved }) => {
    const { t } = useTranslation();

    return (
        <Box>
            <Grid container spacing={0} sx={{ alignItems: 'center', p: 2 }}>
                <Grid size={{ lg: 15, md: 14, xs: 13 }}>
                    <TitlePreview name={t('Preview')} />
                </Grid>

                <Grid size={{ lg: 3, md: 4, xs: 5 }} textAlign="right">
                    <ChipProposalStatus
                        icon={<ProposalStatusIcon hasApproved={hasApproved} />}
                        label={getStatusProposalLabel(hasApproved)}
                    />
                </Grid>

                <Grid size={18} sx={{ pl: '40px' }}>
                    <HeaderBreadcrumbs
                        creditId={creditId}
                        fromQuote={fromQuote}
                    />
                </Grid>
            </Grid>

            <Divider sx={{ mb: 0 }} />
        </Box>
    );
};

HeaderPreview.propTypes = {
    creditId: PropTypes.string,
    fromQuote: PropTypes.bool,
    hasApproved: PropTypes.bool,
};

export default HeaderPreview;
